import { cn } from '@tripleten/cn';

export const cnError = cn('error');
